export enum UserAccountFeature {
    Admin = 'Account.Admin',
    ProjectManager = 'Account.ProjectManager',
    Finance = 'Account.Finance',
    Operator = 'Account.Operator'
}
